var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewRequestSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.772 25.8571H26.6291V37H22.9148V25.8571H11.772V22.1429H22.9148V11H26.6291V22.1429H37.772V25.8571Z",
    fill: "#848587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRequestSupplyReqIcon);
export default __webpack_public_path__ + "static/media/new-request-supply-req-icon.9e318e074b7b5346a80bf58c5f365642.svg";
export { ForwardRef as ReactComponent };